import { render, staticRenderFns } from "./FactAnimatedBg.vue?vue&type=template&id=b21a78fa&scoped=true"
import script from "./FactAnimatedBg.vue?vue&type=script&lang=js"
export * from "./FactAnimatedBg.vue?vue&type=script&lang=js"
import style0 from "./FactAnimatedBg.vue?vue&type=style&index=0&id=b21a78fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21a78fa",
  null
  
)

export default component.exports